import React, { Component } from 'react';
import { array, func, object, string } from 'prop-types';
import _ from 'lodash';
import { Provider } from 'react-redux';
import { Context } from '../Context';
import createCollectStore from '../../store';
import { setCollections } from '../../actions';
import eventsReporter from '../../utils/events/reporter';

const CollectProviderWrapper = (WrappedComponent) => {

    class CollectProvider extends Component {

        constructor(props) {
            super(props);

            const {
                collections,
                resource,
                onUpdateCollections,
                sourceInfo,
                tooltipClassName
            } = props;

            this.store = createCollectStore(this.formatCollections(collections));

            this.collectContext = {
                onUpdateCollections,
                tooltipClassName,
                resource: {
                    ...resource,
                    id: resource.id.toString()
                }
            };

            eventsReporter.enrich({ sourceInfo });
        }

        componentDidUpdate(prevProps) {
            const { collections } = this.props;

            if (prevProps.collections !== collections) {
                const formattedCollections  = this.formatCollections(collections);
                this.store.dispatch(setCollections(formattedCollections));
            }
        }

        formatCollections(collections) {
            return collections.map((collection) => {
                const { items = [] } = collection;
                const formattedItems = items.map(({ resourceId, ...item }) => ({
                    ...item,
                    resourceId: resourceId.toString()
                }));

                return {
                    ...collection,
                    items: formattedItems
                };
            });
        }

        render() {
            return (
                <Context.Provider value={this.collectContext}>
                    <Provider store={this.store}>
                        <WrappedComponent {...this.props}/>
                    </Provider>
                </Context.Provider>
            );
        }
    }

    CollectProvider.propTypes = {
        collections: array,
        resource: object,
        onUpdateCollections: func,
        sourceInfo: object,
        tooltipClassName: string
    };

    CollectProvider.defaultProps = {
        collections: [],
        onUpdateCollections: _.noop,
        sourceInfo: {}
    };

    return CollectProvider;
};

export default CollectProviderWrapper;
